import Swiper from 'swiper';
import { A11y, Autoplay, Navigation } from 'swiper/modules';

if (prestashop.page.page_name == 'cart') {
  document.addEventListener('click', function (e) {
    if (e.target.closest('.remove-from-cart')) {
      e.preventDefault();
      sendProductsId(prestashop.cart);
    }
  });
}

document.addEventListener('DOMContentLoaded', () => {
  if (typeof crossSellingController === 'undefined') {
    return;
  }

  onSubmitRelatedProduct();
  mountSlidersByElementsList();

  if (prestashop.page.page_name == 'cart') {
    prestashop.on('updateCart', e => {
      sendProductsId(e.resp.cart);
    });
  } else if (prestashop.page.page_name == 'product') {
    prestashop.on('updatedCart', e => {
      sendProductsId(e.resp.cart);
    });
  }
});

const mountSlidersByElementsList = () => {
  const productsSlidersList = document.querySelectorAll('.swiper-cross-selling');

  productsSlidersList.forEach(element => {
    let isAutoPlay = element.classList.contains('autoplay');
    let isLoop = element.classList.contains('loop');

    new Swiper(element, {
      modules: [Navigation, A11y, Autoplay],
      slidesPerView: 1,
      spaceBetween: 32,
      loop: isLoop,
      autoplay: isAutoPlay,
      navigation: {
        nextEl: '.btn-carousel-next',
        prevEl: '.btn-carousel-prev',
      },
      breakpoints: {
        700: {
          slidesPerView: 2,
        },
        992: {
          slidesPerView: 3,
        },
        1440: {
          slidesPerView: 4,
        },
      },
    });
  });
};

function onSubmitRelatedProduct() {
  $('.related-products-form').on('submit', function (event) {
    event.preventDefault();

    const form = $(this);
    const token = form.find('input[name="token"]').val();
    const idProduct = form.find('input[name="id_product"]').val();
    let idAttribute = form.find('input[name="id_product_attribute"]').val();
    idAttribute = idAttribute ? idAttribute : 0;
    const add = form.find('input[name="add"]').val();
    const action = form.find('input[name="action"]').val();
    const button = form.find('.related-products-button');

    button.prop('disabled', true);

    $.ajax({
      type: 'POST',
      url: form.attr('action'),
      data: {
        ajax: true,
        id_product: idProduct,
        id_product_attribute: idAttribute,
        add: add,
        action: action,
        token: token,
      },
      success: function (resp) {
        prestashop.emit('updateCart', {
          reason: {
            idProduct: idProduct,
            idProductAttribute: idAttribute,
            ...(prestashop.page.page_name != 'cart' && {
              linkAction: 'add-to-cart',
            }),
          },
          resp: JSON.parse(resp),
        });
        setTimeout(() => {
          button.prop('disabled', false);
        }, 3000);
      },
      error: function (jqXHR, textStatus, errorThrown) {
        console.error('AJAX Error:', textStatus, errorThrown);
        button.prop('disabled', false);
      },
    });
  });
}

function sendProductsId(cart) {
  if (typeof crossSellingController === 'undefined') {
    return;
  }

  const productsId = cart.products.map(product => product.id_product);
  const crossSellingWrapper = document.querySelector('.crossSelling-wrapper');

  if (productsId.length === 0) {
    crossSellingWrapper.innerHTML = '';
    return;
  }

  $.ajax({
    type: 'POST',
    url: crossSellingController,
    data: {
      ajax: true,
      productsId: productsId,
    },
    success: function (resp) {
      try {
        let parsedResp = JSON.parse(resp);
        if (parsedResp.status === 'success' && parsedResp.html) {
          crossSellingWrapper.innerHTML = parsedResp.html;
          mountSlidersByElementsList();
          onSubmitRelatedProduct();
        }
      } catch {
        onSubmitRelatedProduct();
      }
    },
    error: function (jqXHR, textStatus, errorThrown) {
      console.error('AJAX Error:', textStatus, errorThrown);
    },
  });
}
